export default __webpack_public_path__ + "static/media/error_img.bd3ae135.jpg";